import React from 'react';
import classNames from 'classnames';

import ToggleSwitch from 'components/ToggleSwitch';

import './styles.css';

interface ToggleFilterProps {
  label: string;
  value: boolean;
  onChange: () => void;
  classNameForTesting?: string;
}

const ToggleFilter = ({
  label,
  value,
  onChange,
  classNameForTesting
}: ToggleFilterProps) => (
  <div
    className={classNames(
      'FilterSection FilterSection--opened ToggleFilter',
      classNameForTesting
    )}>
    <div className="FilterSection__header colab-centered-v colab-bold colab-row-space-between">
      <div>{label}</div>
      <ToggleSwitch value={value} onChange={onChange} />
    </div>
  </div>
);

export default ToggleFilter;
